import { render, staticRenderFns } from "./HdsSnackbar.vue?vue&type=template&id=36ab2d72&scoped=true&"
import script from "./HdsSnackbar.vue?vue&type=script&lang=ts&"
export * from "./HdsSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./HdsSnackbar.vue?vue&type=style&index=0&id=36ab2d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab2d72",
  null
  
)

export default component.exports